import kacheln from "./kacheln"


export default { kacheln };
